export default __webpack_public_path__ + "static/media/factory-future.fab983ce.svg";